import React, { useEffect, useState } from "react";
import { Card, Table, Button, Popconfirm, message } from "antd";
import Service from "../../services/staff";
import { columns } from "./tableConfigs";
import StaffForm from "./form";

const Staff = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState(null);

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const res = await Service.getStaff();
      setData(res.data || []);
    } catch {
      message.error("Failed to load staff");
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = () => {
    console.log('dddd');

    setSelectedStaffId(null);
    setModalOpen(true);
  };

  const openEditModal = (id) => {
    setSelectedStaffId(id);
    setModalOpen(true);
  };

  const onDelete = async (id) => {
    try {
      await Service.deleteStaff(id);
      message.success("Staff deleted");
      fetchStaff();
    } catch {
      message.error("Delete failed");
    }
  };

  const actionRenderer = (id) => (
    <>
      <Button type="link" onClick={() => openEditModal(id)}>
        Edit
      </Button>
      <Popconfirm title="Delete?" onConfirm={() => onDelete(id)}>
        <Button type="link" danger>
          Delete
        </Button>
      </Popconfirm>
    </>
  );

  return (
    <>
      <Card
        title="Manage Staff"
        extra={
          <Button type="primary" onClick={openAddModal}>
            Add Staff
          </Button>
        }
      >
        <Table
          loading={loading}
          dataSource={data.map(u => ({
            key: u._id,
            name: u.name,
            email: u.email,
            isActive: u.isActive ? "Yes" : "No",
            action: actionRenderer(u._id)
          }))}
          columns={columns()}
        />
      </Card>

      <StaffForm
        visible={modalOpen}
        staffId={selectedStaffId}
        onClose={() => setModalOpen(false)}
        onSuccess={fetchStaff}
      />
    </>
  );
};

export default Staff;
